import React from 'react'
import { Helmet } from 'react-helmet'
import { About, Blog, Contacts, Education, Experience,ExperienceTwo, Landing, Navbar, Projects, Skills } from '../../components'
import { headerData } from '../../data/headerData'

function HomePage() {
    return (
        <div>
            <Helmet>
                <title>{headerData.name}</title>
            </Helmet>
            <Navbar />
            <Landing />
            {/* <About /> */}
            <Skills />
            <Projects />
            <Experience />
            {/* <ExperienceTwo /> */}
            {/* <Education /> */}
            {/* <Blog /> */}
            <Contacts />
        </div>
    )
}

export default HomePage
